import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import CheckBoxes from "./CheckBoxes";
import {
  GroupedPermissions,
  PermissionList,
  RolePermissionData,
  UpdateRole,
} from "../types";
import { formDirty } from "../Atoms/atoms";
import { useSetRecoilState } from "recoil";

export default function PermissionRoles(props: {
  d: RolePermissionData;
  i: number;

  roleData: UpdateRole[];
  setRoleData: React.Dispatch<React.SetStateAction<UpdateRole[]>>;
  id: number;
}) {
  const { d, i, roleData, setRoleData, id } = props;
  const [checkAll, setCheckAll] = useState(Boolean);
  const [checkAllView, setCheckAllView] = useState(Boolean);
  const [checkAllAdd, setCheckAllAdd] = useState(Boolean);
  const [checkAllEdit, setCheckAllEdit] = useState(Boolean);
  const [checkAllDelete, setCheckAllDelete] = useState(Boolean);
  const [operation, setOperation] = useState("");

  const [list, setList] = useState<PermissionList[]>([]);

  const [oldData, setOldData] = useState<PermissionList[]>([]);
  const setDirty = useSetRecoilState(formDirty);

  useEffect(() => {
    let updatesOfList: any[] = [];

    d.groupedPermissions.forEach((subModule) => {
      let all = false;
      let add;
      let edit;
      let view;
      let Delete;

      if (subModule.permissions.add !== null) {
        add = subModule.permissions.add.status;
      }
      if (subModule.permissions.edit !== null) {
        edit = subModule.permissions.edit.status;
      }
      if (subModule.permissions.delete !== null) {
        Delete = subModule.permissions.delete.status;
      }
      if (subModule.permissions.view !== null) {
        view = subModule.permissions.view.status;
      }
      if (
        (add === true || add === undefined) &&
        (edit === true || edit === undefined) &&
        (view === true || view === undefined) &&
        (Delete === true || Delete === undefined)
      ) {
        all = true;
      }

      updatesOfList.push({ all, add, edit, view, delete: Delete });
    });

    setList([...updatesOfList]);
    if (oldData.length === 0) setOldData([...updatesOfList]);
    DATAReady([...updatesOfList]);
  }, [oldData]);

  const Allcheck = (value: boolean) => {
    setDirty(true);
    let updatedList = [...list];
    let updatedRoleData = [...roleData];

    updatedList.forEach((permission, index) => {
      if (value) {
        permission.all = true;
        permission.view = true;
        permission.add = permission.add !== undefined ? true : undefined;
        permission.edit = permission.edit !== undefined ? true : undefined;
        permission.delete = permission.delete !== undefined ? true : undefined;
      } else {
        permission.all = false;
        permission.view = false;
        permission.add = permission.add !== undefined ? false : undefined;
        permission.edit = permission.edit !== undefined ? false : undefined;
        permission.delete = permission.delete !== undefined ? false : undefined;
      }

      if (permission.delete || permission.add || permission.edit) {
        permission.view = true;
      }

      ["view", "add", "edit", "delete"].forEach((action) => {
        let permId =
          d.groupedPermissions[index].permissions[action]?.permissionId;
        if (permId) {
          let existingPermission = updatedRoleData.find(
            (item) => item.permissionId === permId
          );
          if (existingPermission) {
            existingPermission.status = permission[action] ?? false;
          } else {
            updatedRoleData.push({
              id: id,
              permissionId: permId,
              status: permission[action] ?? false,
            });
          }
        }
      });
    });

    updatedRoleData = updatedRoleData.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (saveList) => saveList.permissionId === item.permissionId
        )
    );

    setRoleData([...updatedRoleData]);
    setList(updatedList);
    setCheckAll(value);
    setCheckAllView(value);
    setCheckAllAdd(value);
    setCheckAllEdit(value);
    setCheckAllDelete(value);
  };

  const Allview = (value: boolean) => {
    setDirty(true);
    let updatedList = [...list];
    let updatedRoleData = [...roleData];

    updatedList.forEach((permission, index) => {
      permission.view = value;

      if (value === false) {
        permission.all = false;
        if (permission.add !== undefined) permission.add = false;
        if (permission.edit !== undefined) permission.edit = false;
        if (permission.delete !== undefined) permission.delete = false;

        ["view", "add", "edit", "delete"].forEach((sign) => {
          let permId =
            d.groupedPermissions[index].permissions[sign]?.permissionId;
          if (permId) {
            const existingIndex = updatedRoleData.findIndex(
              (item) => item.permissionId === permId
            );
            if (existingIndex !== -1) {
              updatedRoleData[existingIndex].status = false;
            } else {
              updatedRoleData.push({
                id: id,
                permissionId: permId,
                status: false,
              });
            }
          }
        });
      } else {
        if (
          permission.add === undefined &&
          permission.edit === undefined &&
          permission.delete === undefined
        ) {
          permission.all = true;
        }

        ["view"].forEach((sign) => {
          let permId =
            d.groupedPermissions[index].permissions[sign]?.permissionId;
          if (permId) {
            const existingIndex = updatedRoleData.findIndex(
              (item) => item.permissionId === permId
            );
            if (existingIndex !== -1) {
              updatedRoleData[existingIndex].status = true;
            } else {
              updatedRoleData.push({
                id: id,
                permissionId: permId,
                status: value,
              });
            }
          }
        });
      }
    });

    updatedRoleData = updatedRoleData.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (saveList) => saveList.permissionId === item.permissionId
        )
    );

    setRoleData(updatedRoleData);
    setCheckAllView(value);

    if (value === false) {
      setCheckAll(false);
      setCheckAllAdd(false);
      setCheckAllEdit(false);
      setCheckAllDelete(false);
    } else {
      if (checkAllAdd && checkAllEdit && checkAllDelete) {
        setCheckAll(true);
      }
    }

    setList(updatedList);
  };

  const Alladd = (value: boolean) => {
    setDirty(true);
    let updatedList = [...list];
    let updatedRoleData = [...roleData];

    updatedList.forEach((permission, index) => {
      if (permission.add !== undefined) {
        permission.add = value;
      }
      if (value === true) {
        if (permission.add !== undefined) {
          permission.view = true;
        }
        if (
          (permission.delete === true || permission.delete === undefined) &&
          (permission.edit === true || permission.edit === undefined) &&
          permission.view === true
        ) {
          permission.all = true;
        } else {
          permission.all = false;
        }
      } else {
        if (permission.add !== undefined) {
          permission.all = false;
        }
      }
      let addPermId =
        d.groupedPermissions[index].permissions["add"]?.permissionId;
      let viewPermId =
        d.groupedPermissions[index].permissions["view"]?.permissionId;

      if (addPermId) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === addPermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: addPermId,
            status: value,
          });
        }
      }

      if (viewPermId && permission.add === true) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === viewPermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: viewPermId,
            status: value,
          });
        }
      }
    });

    updatedRoleData = updatedRoleData.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (saveList) => saveList.permissionId === item.permissionId
        )
    );

    setList(updatedList);
    setRoleData(updatedRoleData);
    setCheckAllAdd(value);

    if (value === true) {
      if (list.every((permission) => permission.view === true)) {
        setCheckAllView(true);
      }
      if (checkAllDelete && checkAllEdit && checkAllView) {
        setCheckAll(true);
      }
    } else {
      setCheckAll(false);
    }
  };

  const Alledit = (value: boolean) => {
    setDirty(true);
    let updatedList = [...list];
    let updatedRoleData = [...roleData];

    updatedList.forEach((permission, index) => {
      if (permission.edit !== undefined) {
        permission.edit = value;
      }
      if (value === true) {
        if (permission.edit !== undefined) {
          permission.view = true;
        }
        if (
          (permission.add === true || permission.add === undefined) &&
          (permission.delete === true || permission.delete === undefined) &&
          permission.view === true
        ) {
          permission.all = true;
        } else {
          permission.all = false;
        }
      } else {
        if (permission.edit !== undefined) {
          permission.all = false;
        }
      }
      let editPermId =
        d.groupedPermissions[index].permissions["edit"]?.permissionId;
      let viewPermId =
        d.groupedPermissions[index].permissions["view"]?.permissionId;

      if (editPermId) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === editPermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: editPermId,
            status: value,
          });
        }
      }

      if (viewPermId && permission.edit === true) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === viewPermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: viewPermId,
            status: value,
          });
        }
      }
    });

    updatedRoleData = updatedRoleData.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (saveList) => saveList.permissionId === item.permissionId
        )
    );

    setList(updatedList);
    setRoleData(updatedRoleData);
    setCheckAllEdit(value);

    if (value === true) {
      if (list.every((permission) => permission.view === true)) {
        setCheckAllView(true);
      }
      if (checkAllDelete && checkAllAdd && checkAllView) {
        setCheckAll(true);
      }
    } else {
      setCheckAll(false);
    }
  };

  const Alldelete = (value: boolean) => {
    setDirty(true);
    let updatedList = [...list];
    let updatedRoleData = [...roleData];

    updatedList.forEach((permission, index) => {
      if (permission.delete !== undefined) {
        permission.delete = value;
      }
      if (value === true) {
        if (permission.delete !== undefined) {
          permission.view = true;
        }
        if (
          (permission.add === true || permission.add === undefined) &&
          (permission.edit === true || permission.edit === undefined) &&
          permission.view === true
        ) {
          permission.all = true;
        } else {
          permission.all = false;
        }
      } else {
        if (permission.delete !== undefined) {
          permission.all = false;
        }
      }
      let deletePermId =
        d.groupedPermissions[index].permissions["delete"]?.permissionId;
      let viewPermId =
        d.groupedPermissions[index].permissions["view"]?.permissionId;

      if (deletePermId) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === deletePermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: deletePermId,
            status: value,
          });
        }
      }

      if (viewPermId && permission.delete === true) {
        const existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === viewPermId
        );
        if (existingIndex !== -1) {
          updatedRoleData[existingIndex].status = value;
        } else {
          updatedRoleData.push({
            id: id,
            permissionId: viewPermId,
            status: value,
          });
        }
      }
    });

    updatedRoleData = updatedRoleData.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (saveList) => saveList.permissionId === item.permissionId
        )
    );

    setList(updatedList);

    setRoleData(updatedRoleData);
    setCheckAllDelete(value);

    if (value === true) {
      if (list.every((permission) => permission.view === true)) {
        setCheckAllView(true);
      }
      if (checkAllEdit && checkAllAdd) {
        setCheckAll(true);
      }
    } else {
      setCheckAll(false);
    }
  };

  const Selected = (
    value: boolean,
    index: number,
    sign: string,
    permissionId?: number
  ) => {
    setDirty(true);
    let updatesOfList = [...list];
    const actualPermissionId =
      permissionId ||
      d.groupedPermissions[index].permissions[sign]?.permissionId;

    let data: UpdateRole = {
      id: id,
      permissionId: actualPermissionId || 1,
      status: value,
    };

    switch (sign) {
      case "all":
        updatesOfList[index].all = value;

        const permissionTypes = ["view", "add", "edit", "delete"];
        let saveList: number[] = [];

        permissionTypes.forEach((type) => {
          if (
            updatesOfList[index][type] !== undefined &&
            updatesOfList[index][type] !== value &&
            d.groupedPermissions[index]?.permissions[type]?.permissionId
          ) {
            updatesOfList[index][type] = value;
            saveList.push(
              d.groupedPermissions[index].permissions[type].permissionId
            );
          }
        });

        setCheckAllView(updatesOfList.every((p) => p.view === true));
        setCheckAllAdd(
          updatesOfList.every((p) => p.add === true || p.add === undefined)
        );
        setCheckAllEdit(
          updatesOfList.every((p) => p.edit === true || p.edit === undefined)
        );
        setCheckAllDelete(
          updatesOfList.every(
            (p) => p.delete === true || p.delete === undefined
          )
        );
        setCheckAll(updatesOfList.every((p) => p.all === true));

        let updatedRoleDatas = roleData.map((item) => {
          if (saveList.includes(item.permissionId)) {
            return { ...item, status: value };
          }
          return item;
        });

        saveList.forEach((number) => {
          const existingIndex = updatedRoleDatas.findIndex(
            (item) => item.permissionId === number
          );
          if (existingIndex !== -1) {
            updatedRoleDatas[existingIndex].status = value;
          } else {
            updatedRoleDatas.push({
              id: id,
              permissionId: number,
              status: value,
            });
          }
        });

        setRoleData(updatedRoleDatas);

        break;

      case "view":
        updatesOfList[index].view = value;

        if (value === false) {
          if (updatesOfList[index].add !== undefined) {
            updatesOfList[index].add = false;
          }
          if (updatesOfList[index].edit !== undefined) {
            updatesOfList[index].edit = false;
          }
          if (updatesOfList[index].delete !== undefined) {
            updatesOfList[index].delete = false;
          }

          updatesOfList[index].all = false;
        } else {
          if (
            (updatesOfList[index].add === undefined ||
              updatesOfList[index].add === value) &&
            (updatesOfList[index].edit === undefined ||
              updatesOfList[index].edit === value) &&
            (updatesOfList[index].delete === undefined ||
              updatesOfList[index].delete === value)
          ) {
            updatesOfList[index].all = value;
          }
        }

        if (updatesOfList.every((permission) => permission.view === true)) {
          setCheckAllView(true);
          if (
            checkAllAdd === true &&
            checkAllEdit === true &&
            checkAllDelete === true
          ) {
            setCheckAll(true);
          }
        } else {
          setCheckAllView(false);
          if (updatesOfList.every((permission) => permission.all === true)) {
            setCheckAll(true);
          } else {
            if (updatesOfList[index].all !== undefined) {
              setCheckAll(false);
            }
          }
          if (
            updatesOfList.every(
              (permission) =>
                permission.add === false || permission.add === undefined
            )
          ) {
            setCheckAllAdd(false);
          } else {
            if (updatesOfList[index].add !== undefined) {
              setCheckAllAdd(false);
            }
          }
          if (
            updatesOfList.every(
              (permission) =>
                permission.edit === false || permission.edit === undefined
            )
          ) {
            setCheckAllEdit(false);
          } else {
            if (updatesOfList[index].edit !== undefined) {
              setCheckAllEdit(false);
            }
          }
          if (
            updatesOfList.every(
              (permission) =>
                permission.delete === false || permission.delete === undefined
            )
          ) {
            setCheckAllDelete(false);
          } else {
            if (updatesOfList[index].delete !== undefined) {
              setCheckAllDelete(false);
            }
          }
        }

        const viewPermissionId =
          d.groupedPermissions[index].permissions["view"]?.permissionId;

        const updatedRoleData = [...roleData];

        const existingViewIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === viewPermissionId
        );
        if (existingViewIndex !== -1) {
          updatedRoleData[existingViewIndex].status = value;
        } else {
          updatedRoleData.push({
            ...data,
            permissionId: viewPermissionId,
            status: value,
          });
        }
        if (!value) {
          ["add", "edit", "delete"].forEach((perm) => {
            const permId =
              d.groupedPermissions[index].permissions[perm]?.permissionId;
            if (permId) {
              const existingIndex = updatedRoleData.findIndex(
                (item) => item.permissionId === permId
              );
              if (existingIndex !== -1) {
                updatedRoleData[existingIndex].status = false;
              } else {
                updatedRoleData.push({
                  ...data,
                  permissionId: permId,
                  status: false,
                });
              }
            }
          });
        }

        const uniqueRoleData = updatedRoleData.reduceRight((acc, item) => {
          if (!acc.some((i) => i.permissionId === item.permissionId)) {
            acc.unshift(item);
          }
          return acc;
        }, [] as UpdateRole[]);
        setRoleData(uniqueRoleData);
        break;

      case "add":
        updatesOfList[index].add = value;
        if (value) {
          updatesOfList[index].view = value;
          if (
            (updatesOfList[index].edit === value ||
              updatesOfList[index].edit === undefined) &&
            (updatesOfList[index].delete === value ||
              updatesOfList[index].delete === undefined)
          ) {
            updatesOfList[index].all = value;
          }
        } else {
          updatesOfList[index].all = false;
        }
        if (updatesOfList.every((permission) => permission.view === true)) {
          setCheckAllView(true);
        }
        if (
          updatesOfList.every(
            (permission) =>
              permission.add === true || permission.add === undefined
          )
        ) {
          setCheckAllAdd(true);

          if (
            checkAllEdit === true &&
            checkAllDelete === true &&
            checkAllView === true
          ) {
            setCheckAll(true);
          }
        } else {
          if (updatesOfList.every((permission) => permission.view !== true)) {
            setCheckAllView(false);
          }
          setCheckAllAdd(false);
          setCheckAll(false);
        }
        break;
      case "edit":
        updatesOfList[index].edit = value;
        if (value) {
          updatesOfList[index].view = value;
          if (
            (updatesOfList[index].add === value ||
              updatesOfList[index].add === undefined) &&
            (updatesOfList[index].delete === value ||
              updatesOfList[index].delete === undefined)
          ) {
            updatesOfList[index].all = value;
          }
        } else {
          updatesOfList[index].all = false;
        }
        if (updatesOfList.every((permission) => permission.view === true)) {
          setCheckAllView(true);
        }
        if (
          updatesOfList.every(
            (permission) =>
              permission.edit === true || permission.edit === undefined
          )
        ) {
          setCheckAllEdit(true);
          if (
            checkAllAdd === true &&
            checkAllDelete === true &&
            checkAllView === true
          ) {
            setCheckAll(true);
          }
        } else {
          if (updatesOfList.every((permission) => permission.view !== true)) {
            setCheckAllView(false);
          }
          setCheckAllEdit(false);
          setCheckAll(false);
        }
        break;
      case "delete":
        updatesOfList[index].delete = value;

        if (value) {
          updatesOfList[index].view = value;
          if (
            (updatesOfList[index].edit === true ||
              updatesOfList[index].edit === undefined) &&
            (updatesOfList[index].add === true ||
              updatesOfList[index].add === undefined)
          ) {
            updatesOfList[index].all = value;
          }
        } else {
          updatesOfList[index].all = false;
        }
        if (updatesOfList.every((permission) => permission.view === true)) {
          setCheckAllView(true);
        }
        if (
          updatesOfList.every(
            (permission) =>
              permission.delete === true || permission.delete === undefined
          )
        ) {
          setCheckAllDelete(true);
          if (
            checkAllAdd === true &&
            checkAllEdit === true &&
            checkAllView === true
          ) {
            setCheckAll(true);
          }
        } else {
          if (updatesOfList.every((permission) => permission.view !== true)) {
            setCheckAllView(false);
          }
          setCheckAllDelete(false);
          setCheckAll(false);
        }
        break;
    }

    if (sign === "add" || sign === "edit" || sign === "delete") {
      let updatedRoleData = [...roleData];

      const actionPermissionId =
        d.groupedPermissions[index].permissions[sign]?.permissionId;

      const viewPermissionId =
        d.groupedPermissions[index].permissions["view"]?.permissionId;

      if (actionPermissionId) {
        let existingIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === actionPermissionId
        );

        if (existingIndex !== -1) {
          updatedRoleData[existingIndex] = {
            ...updatedRoleData[existingIndex],
            status: value,
          };
        } else {
          updatedRoleData.push({
            ...data,
            permissionId: actionPermissionId,
            status: value,
          });
        }
      }

      if (viewPermissionId) {
        const viewIndex = updatedRoleData.findIndex(
          (item) => item.permissionId === viewPermissionId
        );

        const hasOtherPermissions = ["add", "edit", "delete"].some(
          (perm) => updatesOfList[index][perm] === true
        );

        if (viewIndex !== -1) {
          updatedRoleData[viewIndex].status = hasOtherPermissions
            ? true
            : updatedRoleData[viewIndex].status;
        } else if (hasOtherPermissions) {
          updatedRoleData.push({
            ...data,
            permissionId: viewPermissionId,
            status: true,
          });
        }
      }

      setRoleData([...updatedRoleData]);
    }

    setList(updatesOfList);
  };

  const DATAReady = (list: any[]) => {
    const add = list.every(
      (permission) => permission.add === true || permission.add === undefined
    );
    const edit = list.every(
      (permission) => permission.edit === true || permission.edit === undefined
    );
    const Delete = list.every(
      (permission) =>
        permission.delete === true || permission.delete === undefined
    );
    const all = list.every((permission) => permission.all === true);
    const view = list.every((permission) => permission.view === true);
    if (view) {
      setCheckAllView(true);
    }
    if (all) {
      setCheckAll(true);
    }
    if (add) {
      setCheckAllAdd(true);
    }
    if (edit) {
      setCheckAllEdit(true);
    }
    if (Delete) {
      setCheckAllDelete(true);
    }
  };

  return (
    <>
      <Disclosure key={i} defaultOpen={true}>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn my-1 flex justify-start w-full py-2  text-sm font-medium text-left">
              {open ? (
                <MinusIcon className="text-gray-500 p-px bg-gray-300 rounded-sm  w-3 h-3" />
              ) : (
                <PlusIcon className="text-gray-500 p-px bg-gray-300 rounded-sm  w-3 h-3" />
              )}
              <div>
                <span className="text-quinary font-bold text-sm ml-2">
                  {d.name}
                </span>
              </div>
            </Disclosure.Button>

            <Disclosure.Panel className="px-4 py-2 text-sm bg-gray-50 text-gray-500 shadow-md ">
              <div className="grid grid-cols-6 text-center pb-2  disclosureLabel">
                <div>Permission Name</div>
                <div className="flex ml-10">
                  <input
                    type="checkbox"
                    className="text-center h-5 w-5 mr-2"
                    checked={
                      checkAll ||
                      (checkAllView &&
                        checkAllAdd &&
                        checkAllEdit &&
                        checkAllDelete)
                    }
                    onChange={(e) => {
                      const checked = e.target.checked;
                      Allcheck(checked);
                    }}
                  ></input>
                  All
                </div>

                <div className="flex ml-10">
                  <input
                    type="checkbox"
                    className="text-center h-5 w-5 mr-2"
                    checked={checkAllView}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      Allview(checked);
                    }}
                  ></input>
                  View
                </div>
                <div className="flex ml-10">
                  <input
                    type="checkbox"
                    className="text-center h-5 w-5 mr-2"
                    checked={checkAllAdd}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      Alladd(checked);
                    }}
                  ></input>
                  Add
                </div>
                <div className="flex ml-10">
                  <input
                    type="checkbox"
                    className="text-center h-5 w-5 mr-2"
                    checked={checkAllEdit}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      Alledit(checked);
                    }}
                  ></input>
                  Edit
                </div>
                <div className="flex ml-10">
                  <input
                    type="checkbox"
                    className="text-center h-5 w-5 mr-1"
                    checked={checkAllDelete}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      Alldelete(checked);
                    }}
                  ></input>
                  Deactivate
                </div>
              </div>

              {d.groupedPermissions.map(
                (permission: GroupedPermissions, index: number) =>
                  permission.groupName !== "Field Access" && (
                    <div key={index} className="grid grid-cols-6">
                      <div className="font-semibold text-sm text-center text-primary border-b border-gray-200 py-1">
                        {permission.moduleName}
                      </div>

                      <div className="text-center border-b border-gray-200 pt-2 pl-10">
                        <div>
                          {list.length > 0 && (
                            <CheckBoxes
                              data={list}
                              value={operation}
                              range={"all"}
                              setOperation={setOperation}
                              selected={Selected}
                              index={index}
                            />
                          )}
                        </div>
                      </div>

                      <div className="text-center border-b border-gray-200 pt-2 pl-10">
                        {permission.permissions?.view && list.length > 0 && (
                          <div>
                            <CheckBoxes
                              data={list}
                              value={operation}
                              range={"view"}
                              setOperation={setOperation}
                              selected={Selected}
                              index={index}
                            />
                          </div>
                        )}
                      </div>

                      <div className="text-center border-b border-gray-200 pt-2 pl-10">
                        {permission.permissions?.add && list.length > 0 && (
                          <div>
                            <CheckBoxes
                              data={list}
                              value={operation}
                              range={"add"}
                              setOperation={setOperation}
                              selected={Selected}
                              index={index}
                            />
                          </div>
                        )}
                      </div>

                      <div className="text-center border-b border-gray-200 pt-2  pl-10">
                        {permission.permissions?.edit && list.length > 0 && (
                          <div>
                            <CheckBoxes
                              data={list}
                              value={operation}
                              range={"edit"}
                              setOperation={setOperation}
                              selected={Selected}
                              index={index}
                            />
                          </div>
                        )}
                      </div>

                      <div className="text-center border-b border-gray-200 pt-2 pl-10">
                        {permission.permissions?.delete && list.length > 0 && (
                          <div>
                            <CheckBoxes
                              data={list}
                              value={operation}
                              range={"delete"}
                              setOperation={setOperation}
                              selected={Selected}
                              index={index}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  );
}
